/** Nome exibido na UI (marca pública). Código, rotas e módulos continuam SPM. */
export const APP_DISPLAY_NAME = "Kapital Map";

/** Versão da aplicação exibida no painel de navegação. */
export const APP_VERSION = "1.0.0";
